import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog'
import { Button } from '../ui/button'
import { X } from 'lucide-react'
import { VisuallyHidden } from '../ui/visually-hidden'

interface BulkUploadSuccessModalProps {
  isOpen: boolean
  onClose: () => void
  totalRecords: number
  onViewHistory: () => void
}

export function BulkUploadSuccessModal({
  isOpen,
  onClose,
  totalRecords,
  onViewHistory,
}: BulkUploadSuccessModalProps) {
  const handleViewHistory = () => {
    onClose()
    onViewHistory()
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <VisuallyHidden>
            <DialogTitle>Bulk Upload Success</DialogTitle>
          </VisuallyHidden>
          <VisuallyHidden>
            <DialogDescription>
              Your bulk reward point allocation has been completed successfully. You can now view
              the transaction history to see the new entries.
            </DialogDescription>
          </VisuallyHidden>
        </DialogHeader>

        <button
          onClick={onClose}
          className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground"
        >
          <X className="h-4 w-4" />
          <span className="sr-only">Close</span>
        </button>

        <div className="flex flex-col items-center text-center space-y-6 py-6">
          <h2 className="text-2xl font-semibold text-green-600">Success!!</h2>

          <p className="text-foreground leading-relaxed">
            You've successfully awarded points to {totalRecords} users. Confirmation emails will be
            sent to all recipients.
          </p>

          <Button
            onClick={handleViewHistory}
            className="bg-[#004d28] hover:bg-[#003d20] text-white px-8 py-2 rounded-lg"
          >
            View Transaction History
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
